export const teleplanConstant = {
    OPEN_CHECK: 'TELE_PLAN_OPEN_CHECK',
    CLOSE_CHECK: 'TELE_PLAN_CLOSE_CHECK',
};
